import { render } from "./MobileShortcuts.vue?vue&type=template&id=182d60bd&scoped=true&ts=true"
import script from "./MobileShortcuts.vue?vue&type=script&lang=ts"
export * from "./MobileShortcuts.vue?vue&type=script&lang=ts"

import "./MobileShortcuts.vue?vue&type=style&index=0&id=182d60bd&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182d60bd"]])

export default __exports__